import { mockBtcEvmChainId } from '../config/btc';
import { mockSolEvmChainId } from '../config/sol';
import { mockTonChainId } from '../config/ton';
import {
  btc,
  solana,
  tomoChains,
  tomoEVMChains,
  ton,
} from '../providers/web3Provider/chains';
import { getChainId } from '../providers/web3Provider/chainUtils';

const useChains = () => {
  const chainIds = tomoChains
    .map(chain => {
      return getChainId(chain);
    })
    .filter(item => typeof item === 'number');

  const swapChainIds = [
    // 0,
    1,
    501,
    56,
    42_161,
    8453,
    81457,
    43_114,
    137,
    534_352,
    10,
    59_144,
    8333,
  ];

  const getChain = (chainId: number) => {
    if (chainId === mockSolEvmChainId) {
      return solana;
    }
    if (chainId === mockBtcEvmChainId) {
      return btc;
    }
    if (chainId === mockTonChainId) {
      return ton;
    }

    return tomoEVMChains.find(tomoChain => {
      return tomoChain.chain.id === chainId;
    });
  };

  return {
    evmChains: tomoEVMChains,
    getChainId,
    getChain,
    chains: tomoChains,
    chainIds,
    swapChainIds,
  };
};

export default useChains;
